import { mergeAttributes, Node } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-2";
import CoPilotAttrNode from "./CoPilotAttrNode.vue";

export default Node.create({
    name: "copilotAttr",
    inline: true,
    group: "inline",
    atom: true,
    selectable: true,
    draggable: false,

    addAttributes: function () {
        return {
            name: { default: "" },
            label: { default: "" },
        };
    },

    parseHTML: function () {
        return [{ tag: "copilot-attr" }];
    },

    renderHTML: function (params) {
        return ["copilot-attr", mergeAttributes(params.HTMLAttributes)];
    },

    addNodeView: function () {
        return VueNodeViewRenderer(CoPilotAttrNode);
    },
});
